/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/ban-ts-ignore */
// @ts-ignore

export function debounceFn(miliseconds = 100): MethodDecorator {
  return function(
    target: Record<string, any>,
    propertyKey: string | symbol,
    descriptor: any
  ): TypedPropertyDescriptor<any> {
    Object.defineProperty(target, "timeoutFn", {
      value: 0,
      writable: true
    });
    const originalMethod: Function = descriptor.value;

    descriptor.value = function(...args: any[]) {
      if (this["timeoutFn"]) clearTimeout(this["timeoutFn"]);
      this["timeoutFn"] = setTimeout(() => {
        originalMethod.apply(this, args);
      }, miliseconds);
    };

    return descriptor;
  };
}
